const appRouter = [
    {   //无需登录
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login'),
        meta: { keepAlive: false}
    },
    {   //无需登录
        path: '/',
        name: 'index',
        component: () => import('@/views/home/index'),
        meta: { keepAlive: false}
    },
    {   //无需登录
        path: '/more',
        name: 'more',
        component: () => import('@/views/home/more'),
        meta: { keepAlive: false}
    },
    {   //需要登录
        path: '/detail',
        name: 'detail',
        component: () => import('@/views/atlasDetail/detail'),
        meta: { keepAlive: false}
    },
    // {   //需要登录
    //     path: '/atlasdetail',
    //     name: 'atlasdetail',
    //     component: () => import('@/views/atlasDetail/atlasdetail'),
    //     meta: { keepAlive: false}
    // },
    {   //无需登录
        path: '/cdetail',
        name: 'cdetail',
        component: () => import('@/views/atlasDetail/cdetail'),
        meta: { keepAlive: false}
    },
    {   //无需登录
        path: '/catlasdetail',
        name: 'catlasdetail',
        component: () => import('@/views/atlasDetail/catlasdetail'),
        meta: { keepAlive: false}
    },
    // {  //需要登录
    //     /*path: '/previewdetail/:data', // 路由pramas传参
    //     props: true //路由props传参*/
    //     path: '/previewdetail',
    //     name: 'previewdetail',
    //     component: () => import('@/views/atlasDetail/previewdetail'),
    //     meta: { keepAlive: false}
    // },
    // {   //需要登录
    //     path: '/previewatlas',
    //     name: 'previewatlas',
    //     component: () => import('@/views/atlasDetail/previewatlas'),
    //     meta: { keepAlive: false}
    // },
    {   //无需登录
        path: '/introduction',
        name: 'introduction',
        component: () => import('@/views/atlasDetail/introduction'),
        meta: { keepAlive: false}
    },
    /*{   //需要登录
        path: '/email',
        name: 'email',
        component: () => import('@/views/atlasDetail/email'),
        meta: { keepAlive: false}
    },*/
    {   //需要登录
        path: '/upload',
        name: 'upload',
        component: () => import('@/views/infoupload/upload'),
        meta: { keepAlive: true}
    },
    // {   //需要登录
    //     path: '/updateatlas',
    //     name: 'updateatlas',
    //     component: () => import('@/views/infoupload/updateatlas'),
    //     meta: { keepAlive: true}
    // },
    {   //需要登录
        path: '/updatedetail',
        name: 'updatedetail',
        component: () => import('@/views/infoupload/updatedetail'),
        meta: { keepAlive: true}
    },
    {   //需要登录
        path: '/verifcopyr',
        name: 'verifcopyr',
        component: () => import('@/views/infoupload/verifcopyr'),
        meta: { keepAlive: false}
    },
    {   //无需登录
        path: '/personlist',
        name: 'personlist',
        component: () => import('@/views/personcard/personlist'),
        meta: { keepAlive: false}
    }, 
    {   //无需登录
        path: '/businecard',
        name: 'businecard',
        component: () => import('@/views/personcard/businecard'),
        meta: { keepAlive: false}
    },
    {  //需要登录
        path: '/personcard',
        name: 'personcard',
        component: () => import('@/views/personcard/personCard'),
        meta: { keepAlive: false}
    },
    {   //无需登录
        path: '/unionCard',
        name: 'unionCard',
        component: () => import('@/views/personcard/unionCard'),
        meta: { keepAlive: false}
    }
];

export default appRouter;


// WEBPACK FOOTER //
// ./src/router/router.js